/**
 * R12 — content-generation's skipped-product reasons as labels. A SKIPPED enrichment carries a
 * stable `skipCode` beside its unchanged `errorMessage` text ("not enriched: its detected vertical
 * APPAREL was not selected for this run"); the label is ours, the vertical is read off the text.
 */
import type { TFunction } from 'i18next';

import { humanizeCode } from './run-format';

/** The skip codes content-gen writes (the `run_products` statuses of the same decision). */
export const SKIP_CODES = ['SKIPPED_NOT_SELECTED', 'SKIPPED_NO_PROMPT'] as const;

/** The detected vertical a skip text names ("…vertical APPAREL_AND_ACCESSORIES was…"), or null. */
export function skipVertical(message: string | null | undefined): string | null {
  const match = /vertical\s+([A-Z][A-Z0-9_]*)/.exec(message ?? '');
  return match?.[1] ?? null;
}

/**
 * A skipped product's reason in words — "Not enriched: its vertical (Apparel and accessories)
 * wasn't selected for this batch". Null for no / an unknown code (the caller keeps its own text).
 */
export function skipReasonText(
  t: TFunction<'catalog-v2-content-gen'>,
  skipCode: string | null | undefined,
  message: string | null | undefined,
): string | null {
  if (!skipCode || !(SKIP_CODES as readonly string[]).includes(skipCode)) return null;
  const vertical = skipVertical(message);
  return vertical
    ? t(`skip.${skipCode}`, { vertical: humanizeCode(vertical) })
    : t(`skip.${skipCode}_noVertical`);
}
